import {
  getPatchApiV1ThreeLetterCodeClientAdminsClientMutationFetcher,
  getPatchApiV1ThreeLetterCodeClientAdminsClientMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';
import type { AxiosError } from 'axios';

type Options = {
  /**
   * API 成功時のコールバック
   */
  onSuccess?: () => void;
  /**
   * API 失敗時のコールバック
   */
  onError?: (error: AxiosError<{ errors?: string[] }>) => void;
};

/**
 * クライアント情報更新（PATCH /api/v1/{tlc}/client_admins/client）API hook
 *
 * 利用人数と送付先住所を更新する。
 */
export const usePatchClientAdminsClient = (threeLetterCode: string, options?: Options) =>
  useMutation(
    getPatchApiV1ThreeLetterCodeClientAdminsClientMutationKey(threeLetterCode),
    getPatchApiV1ThreeLetterCodeClientAdminsClientMutationFetcher(threeLetterCode),
    options
  );
